import * as React from 'react';
import { InlineText2, InlineText3 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';
import { ConditionalWrapper } from '@cian/conditional-component';
import { useDeviceType } from '@cian/ui-kit/responsive';

import { NBSP } from '../../constants/symbols';

export const PolicyAgreement: React.FC = () => {
  const deviceType = useDeviceType();

  return (
    <ConditionalWrapper if={deviceType === 'desktop'} ThenComponent={InlineText2} ElseComponent={InlineText3}>
      <>
        <span className={styles['text']} data-testid="policy">
          {deviceType === 'desktop'
            ? 'Продолжая, вы соглашаетесь на'
            : 'Нажимая на кнопку «Оформить заявку» вы соглашаетесь на'}
          {NBSP}
        </span>
        <a href="/help/about/36526/" className={styles['link']}>
          обработку персональных данных
        </a>
      </>
    </ConditionalWrapper>
  );
};

PolicyAgreement.displayName = 'PolicyAgreement';
